import { EMPTY_MESSAGE_BAR_PROPS } from "presentation/model/MessageBar";
import { useState } from "react";
import { createContainer } from "react-tracked";
  
const {
Provider: MessageBarProvider,
useTracked: useMessageBarTracked
} = createContainer(() => useState(EMPTY_MESSAGE_BAR_PROPS), {concurrentMode: true});

export { MessageBarProvider, useMessageBarTracked};